module.exports = __webpack_public_path__ + "media/images/ww50-c50762fcacbe330fecdcec6c61112617.svg";